import React from "react";
import { Box, Button } from "@mui/material";
import { DomainAdd, Business } from "@mui/icons-material";

const LawFirmUserHomeToolbar = ({
  isLegalService,
  setShowAddFirmDialog,
  fetchLawFirmDetails,
  showAddFirmButton = true,
}) => {
  return (
    <Box display="flex" justifyContent="flex-end" px={3} py={1} gap={2}>
      {isLegalService && (
        <>
          {showAddFirmButton && (
            <Button
              onClick={() => setShowAddFirmDialog(true)}
              variant="outlined"
              startIcon={<DomainAdd />}
            >
              Add Another Law Firm
            </Button>
          )}
          <Button
            onClick={fetchLawFirmDetails}
            variant="outlined"
            startIcon={<Business />}
          >
            Change Law Firm
          </Button>
        </>
      )}
    </Box>
  );
};

export default LawFirmUserHomeToolbar;
